// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2ExO8","range":"MonthRangeSwitch_range__1_SUg","disabled":"MonthRangeSwitch_disabled__1JpiS"};